import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { IsicCardFacade, NotificationFacade } from '@ridango/components';
import { BaseComponent, PersonalCodeValidator } from '@ridango/core';
import { Observable } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';

@Component({
    selector: 'rwidget-isic-card-activation',
    templateUrl: './isic-card-activation.component.html',
    styleUrls: ['./isic-card-activation.component.css']
})
export class IsicCardActivationComponent extends BaseComponent implements OnInit, OnDestroy {
    isicCardActivationLoading$: Observable<boolean> = this.isicCardFacade.isIsicCardLoading$;
    _isicCardActivationForm: FormGroup;
    termsAgreed = false;

    constructor(
        public translate: TranslateService,
        public sanitizer: DomSanitizer,
        private notification: NotificationFacade,
        private personalCodeValidator: PersonalCodeValidator,
        private isicCardFacade: IsicCardFacade
    ) {
        super();
    }

    ngOnInit() {
        this._isicCardActivationForm = new FormGroup({
            personal_code: new FormControl('', [Validators.required, this.personalCodeValidator.getValidator()]),
            terms: new FormControl(this.termsAgreed, [Validators.requiredTrue])
        });

        this.isicCardFacade.isIsicCardActivationFinished$
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((isIsicCardActivationFinished) => {
                if (isIsicCardActivationFinished) {
                    this.isicCardFacade.setIsicCardLoading(false);
                    this.isicCardFacade.error$.pipe(take(1)).subscribe((error) => {
                        if (error) {
                            this.handleError(error);
                        } else {
                            this.notification.success(this.translate.instant('LOCAL_ISIC_CARD_ACTIVATION_SUCCESS'));
                        }
                    });
                    this.scrollToTop();
                }
            });
    }

    handleError(e: any) {
        if (e.error.description) {
            this.notification.error(this.translate.instant(e.error.description));
        } else {
            this.notification.error(this.translate.instant(e.error));
        }
    }

    toggleCheckbox() {
        this.termsAgreed = !this.termsAgreed;
        this._isicCardActivationForm.controls['terms'].patchValue(this.termsAgreed);
    }

    submitForm() {
        if (this._isicCardActivationForm.valid) {
            const payload = this._isicCardActivationForm.getRawValue();

            this.isicCardFacade.setIsicCardLoading(true);
            this.isicCardFacade.activateIsicCard(payload);
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
    scrollToTop() {
        document.querySelector('rwidget-alert')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
}
